import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-menu-button',
  templateUrl: './user-menu-button.component.html',
  styleUrls: ['./user-menu-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuButtonComponent {
  @Input()
  isLoggedIn: boolean;
  @Input()
  initial?: string;
  @Input()
  isBoldEnabled: boolean;
  @Input()
  isHybrid: boolean;
  @Input()
  isRecordingsEnabled: boolean;
  @Input()
  helpLink: string;
  @Input()
  canChangePassword: boolean;
  @Input()
  isUserWithMultipleAccount: boolean;
  @Input()
  username: string;
  @Output()
  readonly selectSettings = new EventEmitter<void>();
  @Output()
  readonly selectRecordings = new EventEmitter<void>();
  @Output()
  readonly selectSwitchAccount = new EventEmitter<void>();
  @Output()
  readonly selectChangePassword = new EventEmitter<void>();
  @Output()
  readonly selectLogout = new EventEmitter<void>();
  @Output()
  readonly openUrl = new EventEmitter<string>();
}
